import { isUser } from '../components/Global/LazyLoader';

export const loadFile = filenames => {
	if (isUser) {
		filenames.map(filename => {
			const cssId = btoa(filename);

			if (!document.getElementById(cssId)) {
				const head = document.getElementsByTagName('head')[0];
				const link = document.createElement('link');
				link.id = cssId;
				link.rel = 'stylesheet';
				link.type = 'text/css';
				link.href = filename;
				head.appendChild(link);
			}
			return '';
		});
	}
};
